import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Tile",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-tile",
    args: {
        chooseShopTitle: "",
        detailLink: "#",
        inProduction: "false",
        isFav: "true",
        machineId: "t123456789",
        machineImageUrl: "mock-assets/images/trulaser-station-7000.jpg",
        machineName: "Machine",
        serviceCallModalLink: "#",
        serviceCaseCreateDisabledBodyText: "",
        serviceCaseCreateDisabledHeaderText: "",
        serviceCaseCreationDisabled: "false",
        shopLink: "#",
        shopLink2: "#",
        shopLink2Icon: "",
        shopLink2Target: "",
        shopLink2Title: "",
        shopLinkIcon: "",
        shopLinkTarget: "",
        shopLinkTitle: "",
        syncId: "",
        toggleFavUrl: "togglefav",
        translateFn: "",
    },
    argTypes: {
        chooseShopTitle: {
            control: "string",
        },
        detailLink: {
            control: "string",
        },
        inProduction: {
            control: "boolean",
        },
        isFav: {
            control: "boolean",
        },
        machineId: {
            control: "text",
        },
        machineImageUrl: {
            control: "text",
        },
        machineName: {
            control: "text",
        },
        serviceCallModalLink: {
            control: "text",
        },
        serviceCaseCreateDisabledBodyText: {
            control: "text",
        },
        serviceCaseCreateDisabledHeaderText: {
            control: "text",
        },
        serviceCaseCreationDisabled: {
            control: "boolean",
        },
        shopLink: {
            control: "text",
        },
        shopLink2: {
            control: "text",
        },
        shopLink2Icon: {
            control: "text",
        },
        shopLink2Target: {
            control: "text",
        },
        shopLink2Title: {
            control: "text",
        },
        shopLinkIcon: {
            control: "text",
        },
        shopLinkTarget: {
            control: "text",
        },
        shopLinkTitle: {
            control: "text",
        },
        syncId: {
            control: "text",
        },
        toggleFavUrl: {
            control: "text",
        },
        translateFn: {
            control: "(key: string) => string",
        },
    },
};

const Template = ({
    chooseShopTitle,
    detailLink,
    isFav,
    machineId,
    machineImageUrl,
    machineName,
    serviceCallModalLink,
    serviceCaseCreateDisabledBodyText,
    serviceCaseCreateDisabledHeaderText,
    serviceCaseCreationDisabled,
    shopLink,
    shopLink2,
    shopLink2Icon,
    shopLink2Target,
    shopLink2Title,
    shopLinkIcon,
    shopLinkTarget,
    shopLinkTitle,
    syncId,
    toggleFavUrl,
}) => {
    return html`
        <ux-iws-tile
            choose-shop-title="${chooseShopTitle}"
            detail-link="${detailLink}"
            is-fav="${isFav}"
            machine-id="${machineId}"
            machine-image-url="${machineImageUrl}"
            machine-name="${machineName}"
            service-call-modal-link="${serviceCallModalLink}"
            service-case-create-disabled-body-text="${serviceCaseCreateDisabledBodyText}"
            service-case-create-disabled-header-text="${serviceCaseCreateDisabledHeaderText}"
            service-case-creation-disabled="${serviceCaseCreationDisabled}"
            shop-link="${shopLink}"
            shop-link-2="${shopLink2}"
            shop-link-2-icon="${shopLink2Icon}"
            shop-link-2-target="${shopLink2Target}"
            shop-link-2-title="${shopLink2Title}"
            shop-link-icon="${shopLinkIcon}"
            shop-link-target="${shopLinkTarget}"
            shop-link-title="${shopLinkTitle}"
            sync-id="${syncId}"
            toggle-fav-url="${toggleFavUrl}"
        >
        </ux-iws-tile>
    `;
};

export const Default = Template.bind({});
